export default __webpack_public_path__ + "static/media/debate_10.19e8d82e.JPG";